class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      // this.initCartUrgencyTimer();

      // console.log('remove button click');
      this.checkGiftQuantity();
    });

  }



  checkGiftQuantity() {
    // La subscribe restituisce una funzione per rimuovere l’ascoltatore
    const unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const items = event.cartData?.items;
      console.log('Carrello aggiornato, items:', items);
      if (!items) return;

      let totFree = 0;
      const inner = document.querySelector('.drawer__inner[role="dialog"]');
      if (!inner) return;

      const freeItem = inner.getAttribute('free-item');
      if (!freeItem) return;

      items.forEach(i => {
        if (i.handle === freeItem) totFree++;
      });

      if (totFree === items.length) {
        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        if (!cartItemsEl) return;

        items.forEach((item, index) => {
          if (item.handle === freeItem) {
            const line = index + 1; // line parte da 1
            console.log('update quantity check');
            
            cartItemsEl.updateQuantity(line, 0);
          }
        });
      }

      // IMPORTANTE: rimuove il listener dopo la prima esecuzione
      unsubscribe();
    });
  }



}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    
    // Elementi UI
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    
    // Variabili di stato
    this.isUpdatingCart = false;
    this.pendingCartUpdates = 0;
    this.removingUpsellProduct1 = false;
    this.removingUpsellProduct2 = false;
    this.cartUpdateUnsubscriber = undefined;

    // Debounce per le modifiche di quantità
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    // Delegazione eventi per i toggle
    this.handleToggleEvents = (event) => {
      if (event.target.id === 'cart-upsell-toggle') {
        this.onCartUpsellToggle(event);
      } else if (event.target.id === 'cart-upsell-toggle-2') {
        this.onCartUpsellToggle2(event);
      }
    };
    
    document.addEventListener('change', this.handleToggleEvents);
    
    // Inizializzazione
    this.addCustomUpsell();

    // this.adjustBarraProgressiva();
    // console.log('1');
    this.lastProgressiveText = '';
    this.initObserverDone = false;

    document.addEventListener('DOMContentLoaded', () => {
      this.adjustBarraProgressiva();
      this.initCartUrgencyTimer();
    });
  }


  async adjustBarraProgressiva() {
    console.log('ABP');
    
    const container = document.querySelector('.drawer__inner progressive-bar');
    if(!container) return;
    const barra = container.querySelector('.barra-colore');
    const soglia = parseFloat(container.getAttribute('soglia'));
    const vid = parseFloat(container.getAttribute('vid'));
    const text = container.querySelector('.progressive-bar-desc');
   
    // fetch(`${routes.cart_url}.js`)
    //   .then((response) => response.json())
    //   .then((cartData) => {
    //     if (cartData && cartData.items) {

    //       let totalInCart = 0;

    //       if (cartData.items.length > 0 ) {
    //         cartData.items.forEach(e => {
    //           totalInCart += (e.final_line_price / 100);
    //         });
    //       }

    //       console.log('cart items: ',cartData.items);
          
    //       console.log('totalInCart:: ',totalInCart);

    //       let percentage = totalInCart / soglia * 100;
    //       barra.style.width = percentage > 100 ? `100%` : `${percentage}%`;

    //       if(totalInCart < soglia) {
    //         text.innerText = `Sei a €${(soglia - totalInCart).toFixed(2).replace('.', ',')} di spesa da un gioiello in omaggio`;
    //         if(container.classList.contains('reachedMax')) container.classList.remove('reachedMax');
    //         await toggleProgressiveBarProduct(vid, soglia);
    //       } 

    //       else if (totalInCart >= soglia ) {
    //         text.innerText = `Hai sbloccato un gioello gratis!`;
    //         if(!container.classList.contains('reachedMax')) container.classList.add('reachedMax');
    //         await toggleProgressiveBarProduct(vid, soglia);
    //       }
    //     }
    //   })
    //   .catch((e) => {
    //     console.error('Errore nel recupero dati carrello:', e);
    //   });

    try {
      const response = await fetch(`${routes.cart_url}.js`);
      const cartData = await response.json();

      if (cartData && cartData.items) {
        let totalInCart = 0;

        for (const e of cartData.items) {
          totalInCart += e.final_line_price / 100;
        }

        console.log('cart items:', cartData.items);

        const percentage = (totalInCart / soglia) * 100;
        barra.style.width = percentage > 100 ? '100%' : `${percentage}%`;

        if (totalInCart < soglia ) {
          text.innerText = `Sei a €${(soglia - totalInCart).toFixed(2).replace('.', ',')} di spesa da un gioiello in omaggio`;
          container.classList.remove('reachedMax');
          
          await this.toggleProgressiveBarProduct(vid, soglia, totalInCart, {items: cartData.items});
          
        } else {
          text.innerText = `Hai sbloccato un gioello gratis!`;
          container.classList.add('reachedMax');


          if(!cartData.items.find((d) => d.id == vid)) {
            await this.toggleProgressiveBarProduct(vid, soglia, totalInCart, {items: cartData.items});
            console.log('triggered');
            
          }
        }
      }
    } catch (e) {
      console.error('Errore nel recupero dati carrello:', e);
    }
  }

  async toggleProgressiveBarProduct (vid, soglia, tot, {items}) {
    // 1) controlla se presente nel carrello;

    // 2) se presente e totalInCart > soglia non fa niente
    // 2) se presente e totalInCart < soglia elimina

    // 3) se non presente e totalInCart >= soglia aggiunge
    // 4) se non presente e totalInCart < soglia non fa niente
    
    // console.log(items);
    let isHere = false;

    items.forEach(i => {
      if (i.id == vid) isHere = true;
    });

    console.log('is here: ',isHere,' - tot: ',tot,' - soglia: ',soglia);

    if (isHere && tot < soglia) {
      // elimina

      const cartItems = document.querySelectorAll('.cart-item');
      const $ = Array.from(cartItems).find(item => {
        const input = item.querySelector('input[data-quantity-variant-id]');
        return input && input.getAttribute('data-quantity-variant-id') == vid;
      });

      if (!$) {
        console.error('Prodotto barra non trovato nel carrello: ', vid,' ',typeof vid);
        cartItems.forEach(cartItem => {
          cartItem.querySelectorAll('input[data-quantity-variant-id]').forEach(i => {
            console.log(i.getAttribute('data-quantity-variant-id'),' ',typeof (i.getAttribute('data-quantity-variant-id')));
          });
        });
        return;
      }

      const upsellIndex = $.querySelector('input[data-index]').dataset.index;

      try {
        console.log('toggle barp updateq');
        await this.updateQuantity(upsellIndex, 0, null, vid, 'dntCll');
      } catch (error) {
        console.error('Errore rimozione prodotto barra:', error);
      }

    }

    else if (!isHere && tot >= soglia) {
      // aggiunge
      try {

        
        console.log('aggiunta barP');
        const upsellFormData = new FormData();
        upsellFormData.append('id', vid);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const data = await response.json();

        if (!response.ok || data.status === 'error') {
          throw new Error(data.description || 'Failed to add bar product');
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
       
      } catch (error) {
        console.error('Errore aggiunta prodotto bar:', error);
      }
    }

    else {
      console.log('non faccio un cazzo');
    }
  }

 
  // adjustBarraProgressiva({ items }) {
  //   setTimeout(() => {
  //     const container = document.querySelector('.drawer__inner progressive-bar');
  //     if (!container) return;

  //     const barra = container.querySelector('.barra-colore');
  //     const text = container.querySelector('.progressive-bar-desc');
  //     const soglia = parseFloat(container.getAttribute('soglia'));
  //     if (!barra || !text) return;

   
  //     let totalInCart = 0;
  //     for (const item of items) {
  //       totalInCart += item.line_price;
  //     }        

          
  //     console.log('totalInCart:: ',totalInCart);
  //     let totCartInt = parseInt(totalInCart) / 100;

  //     let percentage = totCartInt / soglia * 100;
  //     barra.style.width = percentage >= 100 ? `100%` : `${percentage}%`;

  //     if(totCartInt < soglia) {
  //       text.innerText = `Sei a €${(soglia - totCartInt).toFixed(2).replace('.', ',')} di spesa da un gioiello in omaggio`;
  //       if(container.classList.contains('reachedMax')) container.classList.remove('reachedMax');
  //     } 

  //     else if (totCartInt >= soglia ) {
  //       text.innerText = `Hai sbloccato un gioello gratis!`;
  //       if(!container.classList.contains('reachedMax')) container.classList.add('reachedMax');
  //     }
  //   }, 0);
  // }


  // async adjustBarraProgressiva() {
  //   const container = document.querySelector('.drawer__inner progressive-bar');
  //   if (!container) return;

  //   const barra = container.querySelector('.barra-colore');
  //   const text = container.querySelector('.progressive-bar-desc');
  //   const soglia = parseFloat(container.getAttribute('soglia'));
  //   if (!barra || !text) return;

  //   // Ripristina subito il testo precedente dal data-attribute
  //   const lastText = container.getAttribute('data-last-text');
  //   if (lastText) text.innerText = lastText;

  //   // Inizializza il MutationObserver solo una volta
  //   if (!this.initObserverDone) {
  //     const observer = new MutationObserver((mutations) => {
  //       mutations.forEach(mutation => {
  //         mutation.addedNodes.forEach(node => {
  //           if (node.nodeType === 1) { // Element
  //             const newTextNode = node.querySelector('.progressive-bar-desc') ||
  //                                 (node.classList.contains('progressive-bar-desc') ? node : null);
  //             if (newTextNode) {
  //               const updatedText = container.getAttribute('data-last-text');
  //               if (updatedText) newTextNode.innerText = updatedText;
  //             }
  //           }
  //         });
  //       });
  //     });

  //     observer.observe(container, { childList: true, subtree: true });
  //     this.initObserverDone = true;
  //   }

  //   let totalInCart = 0;

  //   // Fetch aggiornamento carrello
  //   fetch(`${routes.cart_url}.js`)
  //     .then(response => response.json())
  //     .then(cartData => {
  //       if (!cartData?.items) return;

  //       totalInCart = cartData.items.reduce((acc, e) => acc + e.final_line_price / 100, 0);
  //       barra.style.width = `${Math.min((totalInCart / soglia) * 100, 100)}%`;

  //       let newText;
  //       if (totalInCart < soglia) {
  //         newText = `Sei a €${(soglia - totalInCart).toFixed(2).replace('.', ',')} di spesa da un gioiello in omaggio`;
  //         container.classList.remove('reachedMax');
  //       } else {
  //         newText = `Hai sbloccato un gioello gratis!`;
  //         container.classList.add('reachedMax');
  //       }

  //       // Aggiorna testo e data-attribute
  //       text.innerText = newText;
  //       container.setAttribute('data-last-text', newText);
  //     })
  //     .catch(e => console.error('Errore nel recupero dati carrello:', e));

  //   if (totalInCart >= soglia) {
  //     try {
  //       const upsellFormData = new FormData();
  //       upsellFormData.append('id', container.getAttribute('pid'));
  //       upsellFormData.append('quantity', 1);

  //       const config = fetchConfig('javascript');
  //       config.headers['X-Requested-With'] = 'XMLHttpRequest';
  //       delete config.headers['Content-Type'];
  //       config.body = upsellFormData;

  //       const response = await fetch(`${routes.cart_add_url}`, config);
  //       const data = await response.json();
        
  //       if (!response.ok || data.status === 'error') {
  //         throw new Error(data.description || 'Failed to add upsell product');
  //       }
        
  //       // Triggera un aggiornamento del carrello per sincronizzare l'interfaccia
  //       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
  //     } catch (error) {
  //       console.error('Errore aggiunta prodotto upsell:', error);
  //       // Ripristina lo stato del toggle in caso di errore
  //       this.updateCartUpsellToggleState();
  //     }

  //   }

  //   else {

  //     const cartItems = document.querySelectorAll('.cart-item');
  //     const upsellItem = Array.from(cartItems).find(item => {
  //       const input = item.querySelector('input[data-quantity-variant-id]');
  //       return input && input.getAttribute('data-quantity-variant-id') === container.getAttribute('pid');
  //     });

  //     if (!upsellItem) {
  //       console.error('Prodotto barra non trovato nel carrello.');
        
  //       return;
  //     }

  //     const upsellIndex = upsellItem.querySelector('input[data-index]').dataset.index;

  //     try {
  //       await this.updateQuantity(upsellIndex, 0, null, container.getAttribute('pid'));
       
  //     } catch (error) {
  //       console.error('Errore rimozione prodotto barra:', error);
  //     }

  //   }
  // }







  

  initCartUrgencyTimer() {
    // console.log('funzione timer inzializzata 2.0');
    const minutesEl = document.getElementById('cart-urgency-minutes');
    const secondsEl = document.getElementById('cart-urgency-seconds');
    const TOTAL_TIME = 6 * 60 + 59; // 6:59 in secondi
    const STORAGE_KEY = 'cart-urgency-start-time';

    if (!minutesEl || !secondsEl) return;

    let startTime = localStorage.getItem(STORAGE_KEY);

    if (startTime) {
      startTime = parseInt(startTime, 10);
    } else {
      startTime = Date.now();
      localStorage.setItem(STORAGE_KEY, startTime);
    }

    function updateTimer() {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      let remaining = TOTAL_TIME - elapsed;

      if (remaining <= 0) {
        startTime = Date.now();
        localStorage.setItem(STORAGE_KEY, startTime);
        remaining = TOTAL_TIME;
      }

      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      minutesEl.textContent = minutes < 10 ? '0' + minutes : minutes;
      secondsEl.textContent = seconds < 10 ? '0' + seconds : seconds;
    }

    updateTimer();
    clearInterval(window.cartUrgencyTimer);
    window.cartUrgencyTimer = setInterval(updateTimer, 1000);
  }

  connectedCallback() {
    // Sottoscrizione agli aggiornamenti del carrello
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.onCartUpdate();
    });

    // Caricamento iniziale stato carrello (solo per cart-items, non cart-drawer-items)
    if (this.tagName !== 'CART-DRAWER-ITEMS') {
      this.loadCartState();
    }

    // this.adjustBarraProgressiva();
  }

  disconnectedCallback() {
    // Pulizia: rimuovi sottoscrizioni e listener
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    document.removeEventListener('change', this.handleToggleEvents);
  }

  // --- FUNZIONI DI GESTIONE CARRELLO ---

  validateQuantity(event) {
    console.log('validate quantity');
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  onChange(event) {
    this.validateQuantity(event);
    //aggiunto 13/04/25*/
    // console.log('quantità aggiornato');
    
  }

  loadCartState() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((parsedState) => {
        this.updateCartUpsellToggleState();
        this.updateCartUpsellVisibility(parsedState.item_count);
        this.updateCartUpsellToggleState2();
        this.updateCartUpsellVisibility2(parsedState.item_count);
      })
      .catch(console.error);
  }

  // --- GESTIONE AGGIORNAMENTI CARRELLO CON DEBOUNCE ---

  debouncedOnCartUpdate = debounce(() => {
    this._onCartUpdate();
  }, 300);

  onCartUpdate() {
    if (this.isUpdatingCart) {
      this.pendingCartUpdates++;
      return;
    }

    // console.log('cart-update');
    
    this.isUpdatingCart = true;
    this.pendingCartUpdates = 0;
    this.debouncedOnCartUpdate();
    this.initCartUrgencyTimer();

    // this.checkGiftQuantity();
    
  }

  _onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      this.updateCartDrawer();
    } else {
      this.updateMainCart();
    }

    // Aggiornamento aggiuntivo per barra di progresso
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cartData) => {
        if (cartData && cartData.items) {
          this.updateProgressBar({ items: cartData.items });
          console.log('cart update');
          this.adjustBarraProgressiva({ items: cartData.items });
          this.renderUpsell({ items: cartData.items });
          this.initCartUrgencyTimer();
        }
      })
      .catch((e) => {
        console.error('Errore nel recupero dati carrello:', e);
      });
  }

  updateCartDrawer() {
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        const parsedStateElement = html.querySelector('[data-cart-drawer-state]');
        const parsedState = parsedStateElement ? JSON.parse(parsedStateElement.textContent) : null;
        
        this.updateCartUpsellToggleState();
        this.updateCartUpsellToggleState2();
        this.initCartUrgencyTimer();
        
        if (parsedState) {
          this.updateCartUpsellVisibility(parsedState.item_count);
          this.updateCartUpsellVisibility2(parsedState.item_count);
        }
        
        this.finalizeCartUpdate();
      })
      .catch(console.error);
  }

  updateMainCart() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        
        if (sourceQty) {
          this.innerHTML = sourceQty.innerHTML;
        }

        const parsedStateElement = html.querySelector('[data-cart-state]');
        const parsedState = parsedStateElement ? JSON.parse(parsedStateElement.textContent) : null;
        
        this.updateCartUpsellToggleState();
        this.updateCartUpsellToggleState2();
        
        if (parsedState) {
          this.updateCartUpsellVisibility(parsedState.item_count);
          this.updateCartUpsellVisibility2(parsedState.item_count);
        }
        
        this.finalizeCartUpdate();
      })
      .catch(console.error);
  }

  finalizeCartUpdate() {
    this.isUpdatingCart = false;
    
    if (this.pendingCartUpdates > 0) {
      this.pendingCartUpdates = 0;
      this.onCartUpdate();
    }
  }

  // --- GESTIONE UPSELL TOGGLE #1 ---

  updateCartUpsellToggleState() {
    const cartUpsellToggle = document.getElementById('cart-upsell-toggle');
    const scriptTag = document.querySelector('script[data-cart-upsell-variant-id]');
    const cartUpsellVariantId = scriptTag ? scriptTag.dataset.cartUpsellVariantId : '';
    const cartItems = document.querySelectorAll('.cart-item');

    const upsellItem = Array.from(cartItems).find(item => {
      const input = item.querySelector('input[data-quantity-variant-id]');
      return input && input.getAttribute('data-quantity-variant-id') === cartUpsellVariantId;
    });

    if (cartUpsellToggle && cartUpsellToggle.checked !== !!upsellItem) {
      cartUpsellToggle.checked = !!upsellItem;
    }
  }

  updateCartUpsellVisibility(itemCount) {
    const cartUpsellContainer = document.querySelector('.cart-upsell-toggle-container');
    if (cartUpsellContainer) {
      cartUpsellContainer.classList.toggle('hidden', itemCount === 0);
    }
  }

  onCartUpsellToggle(event) {
    const scriptTag = document.querySelector('script[data-cart-upsell-variant-id]');
    const cartUpsellVariantId = scriptTag ? scriptTag.dataset.cartUpsellVariantId : '';
    const isChecked = event.target.checked;

    if (isChecked) {
      this.addUpsellProduct(cartUpsellVariantId);
    } else {
      if (!this.removingUpsellProduct1) {
        this.removingUpsellProduct1 = true;
        this.removeUpsellProduct(cartUpsellVariantId);
        
        if (this.tagName === 'CART-DRAWER-ITEMS') {
          event.stopImmediatePropagation();
        }
      }
    }
  }

  async addUpsellProduct(cartUpsellVariantId) {
    try {
      const upsellFormData = new FormData();
      upsellFormData.append('id', cartUpsellVariantId);
      upsellFormData.append('quantity', 1);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = upsellFormData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();
      
      if (!response.ok || data.status === 'error') {
        throw new Error(data.description || 'Failed to add upsell product');
      }
      
      // Triggera un aggiornamento del carrello per sincronizzare l'interfaccia
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
    } catch (error) {
      console.error('Errore aggiunta prodotto upsell:', error);
      // Ripristina lo stato del toggle in caso di errore
      this.updateCartUpsellToggleState();
    }
  }

  async removeUpsellProduct(cartUpsellVariantId) {
    const cartItems = document.querySelectorAll('.cart-item');
    const upsellItem = Array.from(cartItems).find(item => {
      const input = item.querySelector('input[data-quantity-variant-id]');
      return input && input.getAttribute('data-quantity-variant-id') === cartUpsellVariantId;
    });

    if (!upsellItem) {
      console.error('Prodotto upsell non trovato nel carrello.');
      this.removingUpsellProduct1 = false;
      // Ripristina lo stato del toggle
      this.updateCartUpsellToggleState();
      return;
    }

    const upsellIndex = upsellItem.querySelector('input[data-index]').dataset.index;

    try {
      console.log('rimozione u1');
      await this.updateQuantity(upsellIndex, 0, null, cartUpsellVariantId);
      this.removingUpsellProduct1 = false;
    } catch (error) {
      console.error('Errore rimozione prodotto upsell:', error);
      this.removingUpsellProduct1 = false;
    }
  }

  // --- GESTIONE UPSELL TOGGLE #2 ---

  updateCartUpsellToggleState2() {
    const cartUpsellToggle = document.getElementById('cart-upsell-toggle-2');
    const scriptTag = document.querySelector('script[data-cart-upsell-variant-id-two]');
    
    if (!cartUpsellToggle || !scriptTag) return;
    
    const cartUpsellVariantId = scriptTag.dataset.cartUpsellVariantIdTwo;
    const cartItems = document.querySelectorAll('.cart-item');

    const upsellItem = Array.from(cartItems).find(item => {
      const input = item.querySelector('input[data-quantity-variant-id]');
      const variantId = input?.getAttribute('data-quantity-variant-id');
      return input && variantId === cartUpsellVariantId;
    });

    if (cartUpsellToggle.checked !== !!upsellItem) {
      cartUpsellToggle.checked = !!upsellItem;
    }
  }

  updateCartUpsellVisibility2(itemCount) {
    const cartUpsellContainer = document.getElementById('cart-upsell-toggle-container-2');
    if (cartUpsellContainer) {
      cartUpsellContainer.classList.toggle('hidden', itemCount === 0);
    }
  }

  onCartUpsellToggle2(event) {
    const scriptTag = document.querySelector('script[data-cart-upsell-variant-id-two]');
    const cartUpsellVariantId = scriptTag ? scriptTag.dataset.cartUpsellVariantIdTwo : '';
    const isChecked = event.target.checked;

    if (isChecked) {
      this.addUpsellProduct2(cartUpsellVariantId);
    } else {
      if (!this.removingUpsellProduct2) {
        this.removingUpsellProduct2 = true;
        this.removeUpsellProduct2(cartUpsellVariantId);
        
        if (this.tagName === 'CART-DRAWER-ITEMS') {
          event.stopImmediatePropagation();
        }
      }
    }
  }

  async addUpsellProduct2(cartUpsellVariantId) {
    try {
      const upsellFormData = new FormData();
      upsellFormData.append('id', cartUpsellVariantId);
      upsellFormData.append('quantity', 1);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = upsellFormData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();
      
      if (!response.ok || data.status === 'error') {
        throw new Error(data.description || 'Failed to add upsell product');
      }
      
      // Triggera un aggiornamento del carrello per sincronizzare l'interfaccia
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
    } catch (error) {
      console.error('Errore aggiunta prodotto upsell 2:', error);
      // Ripristina lo stato del toggle in caso di errore
      this.updateCartUpsellToggleState2();
    }
  }

  async removeUpsellProduct2(cartUpsellVariantId) {
    const cartItems = document.querySelectorAll('.cart-item');
    const upsellItem = Array.from(cartItems).find(item => {
      const input = item.querySelector('input[data-quantity-variant-id]');
      return input && input.getAttribute('data-quantity-variant-id') === cartUpsellVariantId;
    });

    if (!upsellItem) {
      console.error('Prodotto upsell 2 non trovato nel carrello.');
      this.removingUpsellProduct2 = false;
      // Ripristina lo stato del toggle
      this.updateCartUpsellToggleState2();
      return;
    }

    const upsellIndex = upsellItem.querySelector('input[data-index]').dataset.index;

    try {
      console.log('rimozione u2');
      await this.updateQuantity(upsellIndex, 0, null, cartUpsellVariantId);
      
      this.removingUpsellProduct2 = false;
    } catch (error) {
      console.error('Errore rimozione prodotto upsell 2:', error);
      this.removingUpsellProduct2 = false;
    }
  }

  // --- FUNZIONI CORE DEL CARRELLO ---

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, query) {
    this.enableLoading(line);
    console.log('update quantity ', name, line, variantId);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          message = typeof updatedValue === 'undefined' 
            ? window.cartStrings.error 
            : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
        
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        
        
        this.updateProgressBar({ items: parsedState.items });
        this.initCartUrgencyTimer();

        publish(PUB_SUB_EVENTS.cartUpdate, { 
          source: 'cart-items', 
          cartData: parsedState, 
          variantId: variantId 
        });

        this.updateCartUpsellToggleState();
        this.updateCartUpsellVisibility(parsedState.item_count);
        this.updateCartUpsellToggleState2();
        this.updateCartUpsellVisibility2(parsedState.item_count);        
        this.adjustBarraProgressiva();
        this.checkGiftQuantity();
        
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  // ... altre funzioni (updateProgressBar, renderUpsell, addCustomUpsell, updateLiveRegions, getSectionInnerHTML, enableLoading, disableLoading) ...

  updateProgressBar({ items }) {
    setTimeout(() => {
      const progressWrapper = document.getElementById('shipping-gradient');
      if (!progressWrapper) return;
      
      const minSpent = parseInt(progressWrapper.getAttribute('min-spent'));
      const scrittaBarra = document.querySelector('.scritta-barra-progressiva');
      if (!scrittaBarra) return;
      
      let totalValue = 0;
      for (const item of items) {
        totalValue += item.line_price;
      }
      
      const totalFormatted = parseInt(totalValue) / 100;
      const PercSpesa = Math.min((totalValue / minSpent) * 100, 100);
      
      progressWrapper.style.width = `${PercSpesa}%`;
      
      if (PercSpesa === 100) {
        scrittaBarra.innerHTML = `Hai sbloccato la spedizione <b>GRATIS</b>`;
      }
    }, 250);
  }

  renderUpsell({ items }) {
    setTimeout(() => {
      const cart_upsell = document.querySelector('cart-drawer-upsell');
      if (!cart_upsell) return;
      
      const hasUpsell = items.some(item => item.title.toLowerCase().includes('upsell'));
      
      if (hasUpsell) {
        console.log('Upsell nascosto');
        // cart_upsell.style.display = 'none';
      }
    }, 250);
  }

  addCustomUpsell() {
    const upsellButton = document.querySelector(".u-cart-button");
    if (!upsellButton) return;

    upsellButton.addEventListener("click", async (event) => {
      const button = event.currentTarget;
      const upsellFormData = new FormData();
      upsellFormData.append('id', button.dataset.cartUpsellVariantId);
      upsellFormData.append('quantity', 1);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = upsellFormData;

      try {
        await fetch(`${routes.cart_add_url}`, config);
      } catch (error) {
        console.error('Errore aggiunta prodotto upsell personalizzato:', error);
      }
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').textContent = message;
    }

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedHtml.querySelector(selector);
    return selectedElement ? selectedElement.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      overlay.classList.remove('hidden');
    });

    document.activeElement.blur();
    
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => {
      overlay.classList.add('hidden');
    });
  }



  checkGiftQuantity() {

    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cartData) => {
        if (cartData && cartData.items) {
          // cartData.items contiene gli articoli nel carrello
          console.log(cartData.items);

          const inner = document.querySelector('.drawer__inner[role="dialog"]');

          if(!inner) return;

          const freeItem = inner.getAttribute('free-item');
          const pointerItem = inner.getAttribute('pointer-item');

          if(!freeItem || !pointerItem) return;

          let pointerCounter=0;
          let totFree=0;
          
          cartData?.items.forEach(i => {
            if (i.handle === freeItem) totFree++;
          });

          if (totFree === cartData?.items.length && cartData?.items.length > 0) {
            const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
            if (!cartItemsEl) return;

            cartData?.items.forEach((item, index) => {
              if (item.handle === freeItem) {
                const line = index + 1; // line parte da 1
                console.log('update quantity check');
                
                cartItemsEl.updateQuantity(line, 0);
              }
            });
          }

          // console.log('pointerCounter: ',pointerCounter,' -- freeCounter: ',freeCounter);
        }
      })
      .catch((e) => {
        console.error('Errore nel recupero dati carrello:', e);
      });

    // const unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    //   const items = event.cartData?.items;
    //   console.log('Carrello aggiornato, items:', items);
    //   if (!items) return;

    //   let totFree = 0;
    //   const inner = document.querySelector('.drawer__inner[role="dialog"]');
    //   if (!inner) return;

    //   const freeItem = inner.getAttribute('free-item');
    //   if (!freeItem) return;

    //   items.forEach(i => {
    //     if (i.handle === freeItem) totFree++;
    //   });

    //   if (totFree === items.length) {
    //     const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    //     if (!cartItemsEl) return;

    //     items.forEach((item, index) => {
    //       if (item.handle === freeItem) {
    //         const line = index + 1; // line parte da 1
    //         console.log('update quantity check');
            
    //         cartItemsEl.updateQuantity(line, 0);
    //       }
    //     });
    //   }

    //   // IMPORTANTE: rimuove il listener dopo la prima esecuzione
    //   unsubscribe();
    // });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}